// extracted by mini-css-extract-plugin
export var deleteIcon = "_ri-5";
export var deleteOption = "_ri-3";
export var divider = "_ri-2";
export var downloadIcon = "_ri-4";
export var drawer = "_ri-0";
export var drawerFooter = "_ri-6";
export var drawerOpen = "_ri-1";
export var highlighted = "_ri-7";
export var lighterHighlight = "_ri-8";